import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";

@Component({
    selector: "field-tree-node",
    templateUrl: "./field-tree-node.component.html",
})
export class FieldTreeNode {
    @Input() public component;
    @Input() public serviceId;
    @Output() public showFieldOptions = new EventEmitter();

    public selectedField: any;

    public componentSelected(item) {
        this.showFieldOptions.emit(item);
    }

    public expand(p: any) {
        p.expanded = !p.expanded;
    }

    public onClickChild(field: any) {
        this.showFieldOptions.emit(field);
    }
}
